import React, {Component} from "react";

class RadioBtnList extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.value !== nextProps.value
            || JSON.stringify(this.props.list) !== JSON.stringify(nextProps.list)
        )
    }

    handleChange(event) {
        const { id, onChange } = this.props;
        const value = event.target.value;
        onChange(id, value);
    }

    render() {
        const { label, id, value, list } = this.props;
        const { handleChange } = this;

        return (
            <div className="mb-0 d-flex">
                {
                    label && <label className="me-2">{label}</label>
                }
                <div className="d-flex">
                {
                    list.map((item, index) => (
                        <div className="form-check pe-3"  key={index}>
                            <input
                                className="form-check-input"
                                type="radio"
                                id={id + item.value}
                                name={id + item.value}
                                value={item.value}
                                checked={item.value === value}
                                onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor={id + item.value}>{item.label}</label>
                        </div>
                    ))
                }
                </div>
            </div>
        )
    }
}

RadioBtnList.defaultProps = {
    id: '',
    list: [{ label: '', value: '' }],
    value: '',
    onChange: function() {},
}

export default RadioBtnList;
